import { format } from 'date-fns'

const state = {
  today: format(new Date(), 'YYYYMMDD'),
  message: null
}

const getters = {
  date: (state) => (message) => {
    const date = message.get('createdAt')
    if (state.today === format(date, 'YYYYMMDD')) {
      return format(date, 'H:m')
    }
    return format(date, 'M月D日')
  }
}

const mutations = {
  setMessage (state, message) {
    state.message = message
  }
}

const actions = {
  read ({ state }) {
    let status = state.message.get('status')
    status.set('read', true)
    status.save()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
